import { render, staticRenderFns } from "./AccessCodeEditor.vue?vue&type=template&id=06dd6075&scoped=true&"
import script from "./AccessCodeEditor.vue?vue&type=script&lang=js&"
export * from "./AccessCodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./AccessCodeEditor.vue?vue&type=style&index=0&id=06dd6075&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd6075",
  null
  
)

export default component.exports